<template>
  <div id="hint">
    <router-link
      to="/login"
      v-if="$store.state.login && !$store.state.user.mobile"
      class="message animated shake"
    >
      <span>
        <i class="anyteachicon anyteach-tishi" /> 先去验证手机号吧
      </span>
      <i class="anyteachicon anyteach-next" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Hint",
}
</script>

<style lang="scss" scoped>
// @import "../../../static/css/public.scss";
#hint {
  width: 100%;
  padding: 0 5%;
}
.message {
  display: inline-block;
  text-align: center;
  // background: $lightBlue;
  // border: 1px solid $blue;
  // color: $blue;
  // background: $red;
  // border: 1px solid $red;
  // color: white;
  // border-radius: 4px;
  color: $red;
  padding: 8px 10px;
  padding: 10px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  width: 100%;
  font-size: 0.8rem;
  @include avenir-demi();
  display: flex;
  justify-content: space-between;
  i {
    font-size: inherit;
  }
}
</style>
